import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../directives/header";
import Sidebar from "../directives/sidebar";
import Footer from "../directives/footer";
import config from "../coreFIles/config";
import toast, { Toaster } from "react-hot-toast";
import Cookies from "js-cookie";
import JoditEditor from "jodit-react";
import { getCmsPageDetailsAction, updateCmsPageAction } from "../Action/action";

function slugify(value) {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 160);
}

const EditPage = () => {
  const loginData = !Cookies.get("loginSuccessfastenerwarehouseAdmin")
    ? []
    : JSON.parse(Cookies.get("loginSuccessfastenerwarehouseAdmin"));
  if (!loginData || loginData === "") {
    window.location.href = `${config.baseUrl}`;
  }
  if (loginData.role != config.role_admin) {
    window.location.href = `dashboard`;
  }

  const { id } = useParams();
  const editor = useRef(null);
  const [form, setForm] = useState({
    id: "",
    title: "",
    slug: "",
    content: "",
    sort_order: "0",
    is_active: "1",
  });
  const [spinloader, setspinloader] = useState(1);
  const [saving, setSaving] = useState(0);

  const editorConfig = useMemo(
    () => ({
      readonly: false,
      height: 420,
      placeholder: "Enter page content",
      askBeforePasteHTML: false,
      defaultActionOnPaste: "insert_as_html",
      buttons: [
        "source",
        "|",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "ul",
        "ol",
        "|",
        "paragraph",
        "fontsize",
        "|",
        "link",
        "table",
        "|",
        "align",
        "undo",
        "redo",
      ],
      buttonsMD: [
        "bold",
        "italic",
        "underline",
        "|",
        "ul",
        "ol",
        "|",
        "paragraph",
        "link",
        "table",
        "|",
        "undo",
        "redo",
      ],
    }),
    [],
  );

  useEffect(() => {
    getDetails();
  }, [id]);

  const getDetails = async () => {
    const res = await getCmsPageDetailsAction({ id });
    if (res.success && res.data) {
      setForm({
        id: res.data.id,
        title: res.data.title || "",
        slug: res.data.slug || "",
        content: res.data.content || "",
        sort_order: String(res.data.sort_order ?? 0),
        is_active: String(res.data.is_active ?? 1),
      });
    } else {
      toast.error(res.msg || "No data found");
      setTimeout(() => {
        window.location.href = `${config.baseUrl}pages`;
      }, 800);
    }
    setspinloader(0);
  };

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setForm((old) => ({ ...old, [name]: value }));
  };

  const saveRow = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) {
      toast.error("Title is required.");
      return;
    }
    if (!slugify(form.slug) && !slugify(form.title)) {
      toast.error("Slug is required.");
      return;
    }
    setSaving(1);
    const res = await updateCmsPageAction({
      id: form.id,
      title: form.title.trim(),
      slug: slugify(form.slug) || slugify(form.title),
      content: form.content,
      sort_order: form.sort_order || 0,
      is_active: form.is_active,
    });
    setSaving(0);
    if (res.success) {
      toast.success(res.msg);
      setTimeout(() => {
        window.location.href = `${config.baseUrl}pages`;
      }, 800);
    } else {
      toast.error(res.msg || "Something went wrong.");
    }
  };

  return (
    <>
      <Sidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <Toaster />
        <Header />
        <div className="container-lg mb-4">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb my-0 ms-2">
              <li className="breadcrumb-item">
                <span>
                  <a className="homelink" href={`${config.baseUrl}dashboard`}>
                    Home
                  </a>
                </span>
              </li>
              <li className="breadcrumb-item">
                <span>
                  <a className="homelink" href={`${config.baseUrl}pages`}>
                    Pages
                  </a>
                </span>
              </li>
              <li className="breadcrumb-item active">
                <span>Edit Page</span>
              </li>
            </ol>
          </nav>
        </div>
        <div className="body flex-grow-1 px-3">
          <div className="container-lg">
            <div className="row">
              <div className="col-md-12">
                <div className="card mb-4">
                  <div className="card-header">
                    <span>Edit Page</span>
                  </div>
                  <div className="card-body inner-body">
                    {spinloader == 1 ? (
                      <div className="text-center py-4">
                        <img
                          className="loaderImg search-loader"
                          src={config.baseUrl + "images/loader.gif"}
                          height={20}
                          width={20}
                          alt=""
                        />
                      </div>
                    ) : (
                      <form className="row g-3" onSubmit={saveRow}>
                        <div className="col-md-6">
                          <label className="form-label" htmlFor="title">
                            Title
                          </label>
                          <input
                            className="form-control"
                            id="title"
                            name="title"
                            type="text"
                            placeholder="Enter title"
                            value={form.title}
                            onChange={inputHandler}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label" htmlFor="slug">
                            URL slug
                          </label>
                          <input
                            className="form-control"
                            id="slug"
                            name="slug"
                            type="text"
                            placeholder="terms-and-conditions"
                            value={form.slug}
                            onChange={inputHandler}
                          />
                          <small className="text-muted">Frontend URL: /{form.slug || "your-slug"}</small>
                        </div>
                        <div className="col-md-3">
                          <label className="form-label" htmlFor="is_active">
                            Status
                          </label>
                          <select
                            className="form-control"
                            id="is_active"
                            name="is_active"
                            value={form.is_active}
                            onChange={inputHandler}
                          >
                            <option value="1">Active</option>
                            <option value="0">Hidden</option>
                          </select>
                        </div>
                        <div className="col-md-3">
                          <label className="form-label" htmlFor="sort_order">
                            Sort order
                          </label>
                          <input
                            className="form-control"
                            id="sort_order"
                            name="sort_order"
                            type="number"
                            value={form.sort_order}
                            onChange={inputHandler}
                          />
                        </div>
                        <div className="col-md-12">
                          <label className="form-label" htmlFor="content">
                            Content
                          </label>
                          <JoditEditor
                            ref={editor}
                            value={form.content}
                            config={editorConfig}
                            onBlur={(newContent) => setForm((old) => ({ ...old, content: newContent }))}
                          />
                        </div>
                        <div className="col-12 text-end">
                          <a className="btn btn-secondary me-2" href={`${config.baseUrl}pages`}>
                            Cancel
                          </a>
                          <button className="btn btn-primary" type="submit" disabled={saving === 1}>
                            {saving === 1 ? "Processing..." : "Update"}
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default EditPage;
